import React from "react";
import Sidebar from "../components/Sidebar/Sidebar";
import TaskList from "../components/Tasks/TaskList";

const Home = () => {
  return (
    <div className="container relative">
      <Sidebar />
      <TaskList />
    </div>
  );
};

export default Home;
